import { Typography, Grid, Box } from '@material-ui/core';
import { BackDropContainer, ConfirmButton, CustomTypography, CustomSwitch, useStyles } from './styles';
import { COLORS } from 'shared/constants/COLORS';
import { Rectangle } from './styles';
import myImage from '../../../image/Daylight_dark.png';
import { Hidden } from '@material-ui/core';
import { MoonTwoTone } from '@room-match/shared-ui-components';
import { Switch } from '@room-match/shared-ui-components';
import { ARROW } from 'shared/constants/ASSETS_URL';
const ThemeBanner = ({ isFirsTime, handleBannerClick }: { isFirsTime: boolean; handleBannerClick: () => void }) => {
  const classes = useStyles();
  return (
    <>
      <BackDropContainer open={isFirsTime}>
        <Hidden xsDown>
          <Box
            style={{
              width: 100,
              height: 105,
              backgroundColor: 'transparent',
              position: 'absolute',
              borderRadius: 50,
              border: '3px dashed',
              borderColor: COLORS.PRIMARY,
              bottom: 10,
              left: 0,
            }}
          ></Box>
          <img
            src={ARROW}
            style={{
              width: 200,
              height: 200,
              position: 'absolute',
              bottom: 100,
              left: 10,
              zIndex: 999,
              transform: 'scaleX(-1)',

              rotate: '-30deg',
              filter: 'invert(42%) sepia(74%) saturate(1051%) hue-rotate(194deg) brightness(101%) contrast(101%)',
            }}
          />
          <Box className={classes.switchContent}>
            <MoonTwoTone style={{ marginLeft: '7px' }} />
            <Typography variant="body2">Studio</Typography>
            <Switch disabled={false} toggle={() => {}} checked={true} />
          </Box>
        </Hidden>
        <Rectangle zIndex={999}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTypography size={30} weight={700}>
                We've Launched a New Feature
              </CustomTypography>
            </Grid>
            <Grid item xs={12}>
              <Box>
                <img src={myImage} style={{ width: '100%', minWidth: 200, marginInline: 'auto' }} alt="" />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <CustomTypography size={18} weight={700}>
                Active Daylight or Studio Mode
              </CustomTypography>
              <CustomTypography size={16} weight={400} style={{ margin: '15px 0' }}>
                You can now choose from Daylight or Studio mode for your optimal viewing preference. The light and dark
                modes can be controlled using the toggle in the bottom left of the screen
              </CustomTypography>
              <ConfirmButton
                data-cy="new-feature-got-it"
                variant="contained"
                color="primary"
                onClick={handleBannerClick}
              >
                Got it!
              </ConfirmButton>
            </Grid>
          </Grid>
        </Rectangle>
      </BackDropContainer>
    </>
  );
};

export default ThemeBanner;
